import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
// Angular Material
import { DateAdapter, MatDatepickerModule, MatInputModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MatMomentDateModule, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import 'bootstrap';
import { ChartsModule } from 'ng2-charts';
import { ToastyModule } from 'ng2-toasty';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from "ngx-bootstrap/popover";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { AccordionModule } from 'primeng/accordion';
import { CalendarModule } from 'primeng/calendar';
import { DataTableModule } from 'primeng/datatable';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FieldsetModule } from 'primeng/fieldset';
// PRIME-NG MODULES
import { FileUploadModule } from 'primeng/fileupload';
import { PaginatorModule } from 'primeng/paginator';
import { PickListModule } from 'primeng/picklist';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { AppErrorHandler } from './app-error.handler';
// import { DatePickerModule } from 'ng2-datepicker-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AboutComponent } from "./components/about/about.component";
import { AppComponent } from "./components/app.component";
import { BelpexOverviewComponent } from './components/belpex/belpex-overview/belpex-overview.component';
import { BelpexStatisticsComponent } from './components/belpex/belpex-statistics/belpex-statistics.component';
import { CheckingMechanismComponent } from "./components/checking-mechanism/checking-mechanism.component";
import { CoalOverviewComponent } from './components/coal/coal-overview/coal-overview.component';
import { CoalStatisticsComponent } from './components/coal/coal-statistics/coal-statistics.component';
import { CoTwoOverviewComponent } from './components/cotwo/cotwo-overview/cotwo-overview.component';
import { CoTwoStatisticsComponent } from './components/cotwo/cotwo-statistics/cotwo-statistics.component';
import { CustomersAddUpdateComponent } from "./components/customers/customers-add-update.component";
import { CustomersGroupComponent } from "./components/customers/customers-group.component";
import { CustomersMappingComponent } from './components/customers/customers-mapping/customers-mapping.component';
import { CustomersComponent } from "./components/customers/customers.component";
import { DeliveryAddressAddUpdateComponent } from "./components/delivery-address/delivery-address-add-update.component";
import { ElectricityContractComponent } from "./components/electricity/electricity-contract/electricity-contract.component";
import { ElectricityDashboardComponent } from "./components/electricity/electricity-dashboard/electricity-dashboard.component";
import { ElectricityOverviewComponent } from './components/electricity/electricity-overview/electricity-overview.component';
import { ElectricityStatisticsComponent } from "./components/electricity/electricity-statistics/electricity-statistics.component";
import { InjectieContractComponent } from "./components/electricity/injectie-contract/injectie-contract.component";
// CUSTOME COMPONENTS
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { GasThreeAddUpdateComponent } from './components/gas-three/gasthree-addupdate/gasthree-add-update.component';
import { GasThreeOverviewComponent } from './components/gas-three/gasthree-overview/gasthree-overview.component';
import { GasTwoAddUpdateComponent } from './components/gas-two/gastwo-addupdate/gastwo-add-update.component';
import { GasTwoOverviewComponent } from './components/gas-two/gastwo-overview/gastwo-overview.component';
import { GasTwoStatisticsComponent } from './components/gas-two/gastwo-statistics/gastwo-statistics.component';
import { GasContractComponent } from "./components/gas/gas-contract/gas-contract.component";
import { GasDashboardComponent } from "./components/gas/gas-dashboard/gas-dashboard.component";
import { GasOverviewComponent } from './components/gas/gas-overview/gas-overview.component';
import { GasStatisticsComponent } from "./components/gas/gas-statistics/gas-statistics.component";
import { DashboardComponent } from './components/home/dashboard/dashboard.component';
import { HomeComponent } from "./components/home/home.component";
import { LoginComponent } from "./components/login/login.component";
import { NlogComponent } from "./components/nlog/nlog.component";
import { NotFoundComponent } from "./components/not-found/not-found.component";
import { OilOverviewComponent } from './components/oil/oil-overview/oil-overview.component';
import { OilStatisticsComponent } from './components/oil/oil-statistics/oil-statistics.component';
import { PersonalSettingsComponent } from './components/personalsettings/personalsettings.component';
import { RegisterComponent } from "./components/register/register.component";
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component";
import { RolesComponent } from "./components/roles/roles.component";
import { SettingsComponent } from "./components/settings/settings.component";
import { SupplierComponent } from "./components/supplier/supplier.component";
import { UsersAddUpdateComponent } from "./components/users/users-add-update.component";
import { UsersMappingComponent } from './components/users/users-mapping/users-mapping.component';
import { UsersComponent } from "./components/users/users.component";
import { AutofocusDirective } from './directives/autofocus.directive';
import { BootstrapDatepickerDirective } from './directives/bootstrap-datepicker.directive';
import { BootstrapSelectDirective } from './directives/bootstrap-select.directive';
import { BootstrapTabDirective } from './directives/bootstrap-tab.directive';
import { BootstrapToggleDirective } from './directives/bootstrap-toggle.directive';
import { EqualValidator } from './directives/equal-validator.directive';
import { LastElementDirective } from './directives/last-element.directive';
import { GroupByPipe } from './pipes/group-by.pipe';
import { AccountEndpoint } from './services/account-endpoint.service';
import { AccountService } from './services/account.service';
import { AlertService } from './services/alert.service';
import { AppTitleService } from './services/app-title.service';
import { AppTranslationService, TranslateLanguageLoader } from './services/app-translation.service';
import { BelpexService } from './services/belpex.service';
import { CheckingMechanismService } from './services/checking-mechanism.service';
import { CoalService } from './services/coal.service';
import { ConfigurationService } from './services/configuration.service';
import { ContractBaseService } from "./services/contract-base.service";
import { ContractFileService } from "./services/contract-file.service";
import { CoTwoService } from './services/cotwo.service';
import { CustomersGroupService } from "./services/customers-group.service";
import { CustomersMappingService } from './services/customers-mapping.service';
import { CustomersService } from "./services/customers.service";
import { DeliveryAddressService } from "./services/delivery-address.service";
import { EANCodeTypeService } from './services/ean-code-type.service';
import { EANCodeService } from "./services/ean-code.service";
import { EFMigrationsHistoryService } from './services/efmigrations-history.service';
import { ElectricityContractService } from "./services/electricity-contract.service";
// CUSTOME SERVICES
import { ElectricityService } from './services/electricity.service';
import { EndpointFactory } from './services/endpoint-factory.service';
import { EventService } from "./services/event.service";
import { FacilityTypeService } from "./services/facility-type.service";
import { GasContractService } from "./services/gas-contract.service";
import { GasService } from './services/gas.service';
import { GasThreeService } from './services/gasthree.service';
import { GasTwoService } from './services/gatwo.service';
import { LocalStoreManager } from './services/local-store-manager.service';
import { MeterTypeService } from "./services/meter-type.service";
import { MomentUtcDateAdapter } from './services/moment-utc-date-dapter';
import { NlogService } from './services/nlog.service';
import { NotificationEndpoint } from './services/notification-endpoint.service';
import { NotificationService } from './services/notification.service';
import { OilService } from './services/oil.service';
import { RoleServices } from "./services/roles.service";
import { ScrollService } from "./services/scroll.service";
import { SupplierService } from "./services/supplier.service";
import { UsersMappingService } from './services/users-mapping.service';
import { WindowRefService } from "./services/window-ref.service";



@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpModule,
        HttpClientModule,
        FormsModule,
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: TranslateLanguageLoader
            }
        }),
        NgxDatatableModule,
        ToastyModule.forRoot(),
        TooltipModule.forRoot(),
        PopoverModule.forRoot(),
        BsDropdownModule.forRoot(),
        CarouselModule.forRoot(),
        ModalModule.forRoot(),
        ChartsModule,
        RadioButtonModule,
        FileUploadModule,
        DataTableModule,
        TableModule,
        AccordionModule,
        FieldsetModule,
        CalendarModule,
        PickListModule,
        ProgressSpinnerModule,
        DropdownModule,
        DialogModule,
        PaginatorModule,
        LoggerModule.forRoot({ serverLoggingUrl: '/api/NgxLogger/LogError', level: NgxLoggerLevel.DEBUG, serverLogLevel: NgxLoggerLevel.ERROR }),
        MatDatepickerModule,
        MatInputModule,
        MatMomentDateModule,
        NgIdleKeepaliveModule.forRoot()
    ],
    declarations: [
        AppComponent,
        LoginComponent,
        RegisterComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        HomeComponent,
        CustomersComponent,
        CustomersAddUpdateComponent,
        CustomersGroupComponent,
        SettingsComponent,
        FileUploadComponent,
        ElectricityOverviewComponent,
        ElectricityStatisticsComponent,
        ElectricityContractComponent,
        InjectieContractComponent,
        ElectricityDashboardComponent,
        GasOverviewComponent,
        GasStatisticsComponent,
        GasContractComponent,
        GasDashboardComponent,
        DeliveryAddressAddUpdateComponent,
        SupplierComponent,
        UsersComponent,
        RolesComponent,
        UsersAddUpdateComponent,
        AboutComponent,
        NotFoundComponent,
        EqualValidator,
        LastElementDirective,
        AutofocusDirective,
        BootstrapTabDirective,
        BootstrapToggleDirective,
        BootstrapSelectDirective,
        BootstrapDatepickerDirective,
        GroupByPipe,
        PersonalSettingsComponent,
        CustomersMappingComponent,
        UsersMappingComponent,
        NlogComponent,
        CheckingMechanismComponent,
        OilStatisticsComponent,
        OilOverviewComponent,
        CoalStatisticsComponent,
        CoalOverviewComponent,
        CoTwoStatisticsComponent,
        CoTwoOverviewComponent,
        GasTwoStatisticsComponent,
        GasTwoOverviewComponent,
        GasTwoAddUpdateComponent,
        DashboardComponent,
        BelpexOverviewComponent,
        BelpexStatisticsComponent,
        GasThreeOverviewComponent,
        GasThreeAddUpdateComponent,
    ],
    providers: [
        { provide: 'BASE_URL', useFactory: getBaseUrl },
        { provide: ErrorHandler, useClass: AppErrorHandler },
        // Angular Material 2 Datepciker Translation and The locale would typically be provided on the root module of your application.
        { provide: MAT_DATE_LOCALE, useValue: 'nl-be' },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
        { provide: DateAdapter, useClass: MomentUtcDateAdapter },
        AlertService,
        ConfigurationService,
        AppTitleService,
        AppTranslationService,
        NotificationService,
        NotificationEndpoint,
        AccountService,
        AccountEndpoint,
        LocalStoreManager,
        EndpointFactory,
        ElectricityService,
        ElectricityContractService,
        ContractBaseService,
        GasService,
        GasContractService,
        CustomersService,
        CustomersGroupService,
        DeliveryAddressService,
        SupplierService,
        FacilityTypeService,
        MeterTypeService,
        ContractFileService,
        WindowRefService,
        EANCodeTypeService,
        EANCodeService,
        RoleServices,
        EventService,
        ScrollService,
        CustomersMappingService,
        NlogService,
        UsersMappingService,
        CheckingMechanismService,
        EFMigrationsHistoryService,
        OilService,
        CoalService,
        CoTwoService,
        GasTwoService,
        GasThreeService,
        BelpexService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}

export function getBaseUrl() {
    return document.getElementsByTagName('base')[0].href;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/app.module.ts